import { isSameDay } from 'date-fns';
import type { SettingsWeekDay } from '../settings-week/settings-week';
import { getWorkHoursIntervalsForDate } from '../work-hours-interval/get-work-hours-intervals-for-date';
import type { RegularWeekDay } from './regular-week';

export const formatRegularDay = (
  day: SettingsWeekDay,
  date: Date,
  givenDate = new Date(),
  unionHours = true
): RegularWeekDay => ({
  weekday: day.weekday,
  date,
  hours: !day.isClosed
    ? getWorkHoursIntervalsForDate(day.settingsHours, date, unionHours)
    : [],
  isClosed: day.isClosed,
  isToday: isSameDay(date, givenDate)
});
